import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(
    public alertController:AlertController
  ) { }

  async presentMessage(errorMessage:string){
    console.log("present message service : " + errorMessage);
    if(typeof errorMessage !== "undefined"){
      const alert = await this.alertController.create({
        message: errorMessage,
        buttons: [{text:'Ok', role:'cancel'}] 
      });
      await alert.present();
    }
   
  }

  async presentMessageRedirect(errorMessage:string){
    if(typeof errorMessage !== "undefined"){
      const alert = await this.alertController.create({
        message: errorMessage,
        buttons: [{
          text:'Ok', 
          role:'cancel',
          handler: ()=>{
            
          }
        }] 
      });
      await alert.present();
    }
  }

  async present(){
    const alert = await this.alertController.create({
      
      buttons: [{text:'Ok', role:'cancel'}] 
    });
    await alert.present();
  }
}
